// @ts-strict-ignore
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectAddNewUsersToAppsSettingEnabled, selectOrg } from '../../selectors/selectors';
import { OrgComponentProps } from '../../typescriptHelpers';
import { OrgSettingsUpdatable } from '../../actions/updatable';
import { globalMessage } from '../../utils/globalMessage';
import { SettingsSwitchRow } from '../SettingsSwitchRow';
import { tryUpdateOrgSettings, UpdateAddNewUsersToAppsSettingRequest } from '../../actions/orgSettings';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';

const AddNewUsersToAppsSetting: React.FC<OrgComponentProps> = (props) => {
    const dispatch = useDispatch();

    const onSwitchStateChanged = (checked: boolean) => {
        setIsFieldChecked(checked);

        const request: UpdateAddNewUsersToAppsSettingRequest = {
            orgId: props.orgId,
            addNewUsersToAppsSettingEnabled: checked,
        };

        dispatch(tryUpdateOrgSettings(OrgSettingsUpdatable.UpdateAddNewUsersToAppsSetting, request));
    };

    const addNewUsersToAppsSettingEnabled = useSelector((state: RootState) =>
        selectAddNewUsersToAppsSettingEnabled(state, props.orgId),
    );

    const isLoading = useIsLoading(OrgSettingsUpdatable.UpdateAddNewUsersToAppsSetting);
    const error = useError(OrgSettingsUpdatable.UpdateAddNewUsersToAppsSetting);
    const settingUpdated = useUpdated(OrgSettingsUpdatable.UpdateAddNewUsersToAppsSetting);

    const [isFieldChecked, setIsFieldChecked] = React.useState(addNewUsersToAppsSettingEnabled);
    const org = useSelector((state: RootState) => selectOrg(state, props.orgId));

    React.useEffect(() => {
        if (settingUpdated) {
            globalMessage.success('Organization setting updated!');
        }
    }, [settingUpdated]);

    React.useEffect(() => {
        if (error) {
            globalMessage.error(error);
            setIsFieldChecked(addNewUsersToAppsSettingEnabled);
        }
    }, [error]);

    React.useEffect(() => {
        setIsFieldChecked(addNewUsersToAppsSettingEnabled);
    }, [addNewUsersToAppsSettingEnabled]);

    return (
        <SettingsSwitchRow
            disabled={org.ssoSamlConfig.isUsingDirectorySyncDefinedApps}
            title="Add new users to all apps"
            description="New users will be automatically added to all existing apps"
            isLoading={isLoading}
            checked={isFieldChecked}
            onChange={onSwitchStateChanged}
            switchTooltipText={
                org.ssoSamlConfig.isUsingDirectorySyncDefinedApps ?
                    'App membership is being managed by Directory Sync'
                :   null
            }
        />
    );
};

export default AddNewUsersToAppsSetting;
